<template>
  <DefaultLayout body-class="authentication-bg">
    <div class="position-absolute start-0 end-0 start-0 bottom-0 w-100 h-100">
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 800 800">
        <g fill-opacity="0.22">
          <circle style="fill: rgba(var(--ct-primary-rgb), 0.1)" cx="400" cy="400" r="600" />
          <circle style="fill: rgba(var(--ct-primary-rgb), 0.2)" cx="400" cy="400" r="500" />
          <circle style="fill: rgba(var(--ct-primary-rgb), 0.3)" cx="400" cy="400" r="300" />
          <circle style="fill: rgba(var(--ct-primary-rgb), 0.4)" cx="400" cy="400" r="200" />
          <circle style="fill: rgba(var(--ct-primary-rgb), 0.5)" cx="400" cy="400" r="100" />
        </g>
      </svg>
    </div>

    <div class="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5 position-relative">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xxl-4 col-lg-5">
            <div class="card">
              <!-- Logo -->
              <div class="card-header py-4 text-center bg-primary">
                <router-link to="/">
                  <span><img src="@/assets/images/logo.png" alt="logo" height="22" /></span>
                </router-link>
              </div>

              <div class="card-body p-4">
                <div class="text-center w-75 m-auto">
                  <h4 class="text-dark-50 text-center mt-0 fw-bold">Reset Password</h4>
                  <p class="text-muted mb-4">
                    Enter your email address and we'll send you an email with instructions to reset your password.
                  </p>
                </div>

                <form action="#">
                  <div class="mb-3">
                    <label for="emailaddress" class="form-label">Email address</label>
                    <input id="emailaddress" type="email" class="form-control" required placeholder="Enter your email" />
                  </div>

                  <div class="mb-0 text-center">
                    <button class="btn btn-primary" type="submit">Reset Password</button>
                  </div>
                </form>
              </div>
              <!-- end card-body-->
            </div>
            <!-- end card -->

            <div class="row mt-3">
              <div class="col-12 text-center">
                <p class="text-muted">
                  Back to <router-link to="/login" class="text-muted ms-1"><b>Log In</b></router-link>
                </p>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
    <!-- end page -->

    <FooterLayout />
  </DefaultLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import DefaultLayout from '@/views/components/layouts/default-layout.vue'
import FooterLayout from '@/views/components/layouts/partials/footer.vue'

export default defineComponent({
  components: { DefaultLayout, FooterLayout },
})
</script>
